import { render, staticRenderFns } from "./GoliaShareNetwork.vue?vue&type=template&id=89bd6d6c&scoped=true"
import script from "./GoliaShareNetwork.vue?vue&type=script&lang=js"
export * from "./GoliaShareNetwork.vue?vue&type=script&lang=js"
import style0 from "./GoliaShareNetwork.vue?vue&type=style&index=0&id=89bd6d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bd6d6c",
  null
  
)

export default component.exports